import React from 'react'
import { SvgIcon } from '@material-ui/core'

export function KzIcon(props) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_14505_4026)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#338AF3"
        />
        <path
          d="M15.652 10.1084H4.34766C4.34766 10.8888 5.02738 11.5214 5.80773 11.5214H5.7607C5.7607 12.3019 6.39332 12.9345 7.17375 12.9345C7.17375 13.7149 7.80637 14.3475 8.5868 14.3475H11.4129C12.1933 14.3475 12.8259 13.7149 12.8259 12.9345C13.6064 12.9345 14.239 12.3019 14.239 11.5214H14.192C14.9722 11.5214 15.652 10.8888 15.652 10.1084Z"
          fill="#FFDA44"
        />
        <path
          d="M13.914 8.26123C13.914 10.4223 12.162 12.1743 10.0009 12.1743C7.8398 12.1743 6.08789 10.4223 6.08789 8.26123"
          fill="#338AF3"
        />
        <path
          d="M12.9895 8.26024L11.7682 8.83473L12.4185 10.0175L11.0923 9.76383L10.9243 11.1035L10.0006 10.1182L9.07684 11.1035L8.90883 9.76383L7.58266 10.0175L8.23297 8.83469L7.01172 8.26024L8.23301 7.68578L7.58266 6.50301L8.90879 6.75668L9.07687 5.41699L10.0006 6.40235L10.9243 5.41699L11.0923 6.75668L12.4186 6.50301L11.7682 7.68582L12.9895 8.26024Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="clip0_14505_4026">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
